export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-5">
                <i className="ri-smartphone-line text-sm"></i>
                移动端阅读
              </div>
              <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-5">
                随时随地，畅享漫画
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                亲亲漫画完美适配手机与平板浏览器，无需下载安装即可享受流畅的下拉式阅读体验。打开浏览器输入网址，海量免费漫画即刻触手可及。支持添加到手机主屏幕，像原生应用一样快捷访问。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-apple-line text-foreground-600"></i>
                  </div>
                  <span className="text-xs text-foreground-600">添加到主屏幕</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-android-line text-foreground-600"></i>
                  </div>
                  <span className="text-xs text-foreground-600">PWA快捷访问</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-qr-scan-line text-foreground-600"></i>
                  </div>
                  <span className="text-xs text-foreground-600">扫码即看</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-compass-3-line text-base"></i>
                  立即开始阅读
                </a>
                <a
                  href="#faq"
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50 text-foreground-700 font-semibold text-sm rounded-full hover:bg-background-200 transition-colors border border-background-200/70 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-question-line text-base"></i>
                  了解更多
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-full max-w-[360px] aspect-[3/5] rounded-2xl overflow-hidden bg-background-50 border-4 border-background-200/70">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20webtoon%20comic%20reading%20interface%20with%20vertical%20scroll%20style%20panels%2C%20warm%20ambient%20lighting%2C%20modern%20clean%20phone%20frame%2C%20cream%20background%2C%20editorial%20product%20photography%2C%20soft%20shadows&width=720&height=1200&seq=app-mockup-manga&orientation=portrait"
                  alt="亲亲漫画移动端阅读界面展示"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}